import axios from "axios";
import config from "../config";
var qs = require('qs');
import store from '../store/'
import utils from '../util/';
import Router from '../router';
import { runInNewContext } from "vm";
export default {
    checkValidToken(){
        axios.interceptors.response.use((response) => {
            return response;
        }, (error) => {
            if(error.response.status && error.response.status === config.forbiddenAccessStatus){
                let color = config.errMsgColorStr;
                let msg = config.logoutMsg;
                window.getApp.$emit("showSnackbar", {
                    color,
                    msg
                });
                store.dispatch('logout');
                let loginUrl = '/login';
                if(store.state.loginType && store.state.loginType != ''){
                    loginUrl += '/'+store.state.loginType;
                }
                Router.push(loginUrl);
                return false;
            }else if(error.response.status && error.response.status === config.refreshTokenStatus){
                utils.refreshTokenGenerate(store);
                return false;
            }else if(error.response.status && error.response.status === config.passwordEncryptionStatus){
                let color = config.errMsgColorStr;
                let msg = config.passwordEncryptionMsg;
                window.getApp.$emit("showSnackbar", {
                    color,
                    msg
                });
                store.dispatch('logout');
                let loginUrl = '/login';
                if(store.state.loginType && store.state.loginType != ''){
                    loginUrl += '/'+store.state.loginType;
                }
                Router.push(loginUrl);
                return false;
            }else{
                return error;
            }
        });
    },
    post(url, data, headers) {
        let commonHeaders = { 'Content-type': 'application/x-www-form-urlencoded' };
        if (headers) {
            commonHeaders = Object.assign({}, commonHeaders, headers);
        }
        commonHeaders = { 'headers': commonHeaders };
        return new Promise((resolve, reject) => {
            axios.post(config.apiUrl + url, qs.stringify(data), commonHeaders)
                .then(response => {
                    response && response.status === 200 ? resolve(response) : reject(response);
                })
                .catch(err => {
                    reject(err);
                })
        });
    },
    get(url, headers, params = {}) {
        let commonHeaders = { 'Content-type': 'application/x-www-form-urlencoded' };
        if (headers) {
            commonHeaders = Object.assign({}, commonHeaders, headers);
        }
        commonHeaders = { 'headers': commonHeaders };
        if(Object.keys.length) {
            commonHeaders.params = params;
        }
        return new Promise((resolve, reject) => {
            axios.get(config.apiUrl + url, commonHeaders)
                .then(response => {
                    response.status === 200 ? resolve(response) : reject(response);
                })
                .catch(err => {
                    reject(err);
                })
        });
    },
    delete(url, data, headers) {
        return new Promise((resolve, reject) => {
            axios.delete(config.apiUrl + url, { params: data, headers })
                .then(response => {
                    response.status === 200 ? resolve(response) : reject(response);
                })
                .catch(err => {
                    reject(err);
                })
        });
    },
    put(url, data, headers) {
        let commonHeaders = { 'Content-type': 'application/x-www-form-urlencoded' };
        if (headers) {
            commonHeaders = Object.assign({}, commonHeaders, headers);
        }
        commonHeaders = { 'headers': commonHeaders };
        return new Promise((resolve, reject) => {
            axios.put(config.apiUrl + url, qs.stringify(data), commonHeaders)
                .then(response => {
                    response.status === 200 ? resolve(response) : reject(response);
                })
                .catch(err => {
                    reject(err);
                })
        });
    },
    postforum(url, data, headers) {
        let commonHeaders = { 'Content-type': 'application/x-www-form-urlencoded' };
        if (headers) {
            commonHeaders = Object.assign({}, commonHeaders, headers);
        }
        commonHeaders = { 'headers': commonHeaders };
        return new Promise((resolve, reject) => {
            axios.post(url, qs.stringify(data), commonHeaders)
                .then(response => {
                    response.status === 200 ? resolve(response) : reject(response);
                })
                .catch(err => {
                    reject(err);
                })
        });
    },
    postFile(url, data, headers) {
        let commonHeaders = { 'Content-type': 'multipart/form-data' };
        if (headers) {
            commonHeaders = Object.assign({}, commonHeaders, headers);
        }
        commonHeaders = { 'headers': commonHeaders };
        return new Promise((resolve, reject) => {
            axios.post(config.apiUrl + url, data, commonHeaders)
                .then(response => {
                    response.status === 200 ? resolve(response) : reject(response);
                })
                .catch(err => {
                    reject(err);
                })
        });
    },
}


// WEBPACK FOOTER //
// ./src/services/HttpService.js